export const DobValidationMessageStyles = {
  errorMessage: 'pb-6',
}
